import { z } from 'zod';
export const CSV_IMPORT_ENTITIES = ['guest'];
export const csvImportEntitySchema = z.enum(CSV_IMPORT_ENTITIES);
export const csvImportBodySchema = z.object({
    scope: z
        .object({
        eventId: z.string().uuid().optional(),
    })
        .optional(),
    rows: z.array(z.record(z.unknown())).min(1).max(2000),
});
//# sourceMappingURL=csv-import.js.map